module.exports = __webpack_public_path__ + "img/Albania.20aafd07.png";